<div class="modal-header">
  <app-summary-top class="w-100" [header]="header" [showSave]="false"></app-summary-top>
</div>

<div class="modal-body p-3">
  <app-grid
    #contactsGrid
    gridCssClass="email-contact-picker-grid"
    stateKey="EmailContactPicker"
    [columnDefs]="columnDefs"
    [rowData]="contacts()"
    [showDelete]="false"
    [showDiscard]="false"
  ></app-grid>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()" i18n>Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onAdd()" i18n>Add to Cc</button>
</div>
